// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOauthProviderConfigGetBody = {};

export type typeOauthProviderConfigGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    apple: { isEnabled: boolean; webServicesId?: string | null };
    google: { isEnabled: boolean; webClientId?: string | null };
    recaptcha: { siteKey: string; isActive: boolean };
  };
};

export type typeOauthProviderConfigGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthProviderConfigGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthProviderConfigGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOauthProviderConfigGetBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOauthProviderConfigGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOauthProviderConfigGetBody);
  }

  return async function postOauthProviderConfigGet(
    payload: typeOauthProviderConfigGetBody,
  ): Promise<
    typeOauthProviderConfigGetOutput200 | typeOauthProviderConfigGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOauthProviderConfigGet" failed before calling the network. #22c7bf228516`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#22c7bf228516" },
        },
        data: null,
      } as typeOauthProviderConfigGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/oauth/provider-config-get`,
      httpMethod: "POST",
      options,
    })) as
      typeOauthProviderConfigGetOutput200 | typeOauthProviderConfigGetOutput400;
  };
}
